module.exports = __webpack_public_path__ + "img/paused_18.04f92dd5.svg";